
const API_SERVER_PRODUCTION = 'https://api.pubtec.com.br'
const API_SERVER_TEST = 'https://api-teste.pubtec.com.br'
const API_LOCAL_HOST = 'http://localhost:8000'

let SELECTED_API = API_LOCAL_HOST

const PUB_MEDIA_IP_PRODUCTION = 'http://200.150.202.174/media/'

let PUB_MEDIA_IP = PUB_MEDIA_IP_PRODUCTION


if(window.location.hostname === 'localhost' || window.location.hostname == 'dev.pubtec') {
    SELECTED_API = API_SERVER_TEST
    PUB_MEDIA_IP = `${API_SERVER_TEST}/media/`

}else if(window.location.hostname == 'teste.pubtec.com.br'){
    SELECTED_API = API_SERVER_TEST
    PUB_MEDIA_IP = `${API_SERVER_TEST}/media/`
}else{
    SELECTED_API = API_SERVER_PRODUCTION
    PUB_MEDIA_IP = PUB_MEDIA_IP_PRODUCTION
}
    

export const CONFIGS = Object.freeze({ 
    API_SERVER: SELECTED_API,
    PUB_MEDIA_IP: PUB_MEDIA_IP
})